module.exports = __webpack_public_path__ + "img/default-company.41ce1d35.svg";